import {
  HOSTNAME_DEV,
  HOSTNAME_LOCAL,
  HOSTNAME_STAGING,
  HOSTNAME_TEST,
} from "common/constants";

const HeaderLogo = () => {
  let src: string;
  switch (location.hostname) {
    case HOSTNAME_LOCAL:
    case HOSTNAME_DEV:
      src = "/jylha-logo-dev.webp";
      break;
    case HOSTNAME_STAGING:
      src = "/jylha-logo-staging.webp";
      break;
    case HOSTNAME_TEST:
      src = "/jylha-logo-test.webp";
      break;
    default:
      src = "/jylha-logo.webp";
  }

  return (
    <img
      data-testid="jylha-logo"
      src={src}
      alt="Jylhä logo"
      width={137}
      height={34}
      loading="eager"
      decoding="async"
      fetchPriority="high"
      style={{ objectFit: "contain", display: "block" }}
    />
  );
};

export default HeaderLogo;
